import { Component, OnInit, OnChanges, Input, signal, computed } from '@angular/core';
import { FlowObjectDefinition, FlowObjectInstance } from '../../../models/flow-object.model';
import { FlowDefinition, FlowInstance } from '../../../models/flow.model';
import { Utils } from '../../../shared/utils';
import { IMPORTS } from './_imports';

@Component({
    selector: 'fob-cancel-by-schedule',
    templateUrl: './fob-cancel-by-schedule.component.html',
    styleUrl: './fob-cancel-by-schedule.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class FlowObjectCancelByScheduleComponent implements OnInit, OnChanges {
    // #region [signals]
    $model = signal(null as FlowObjectInstance);
    $flowInstance = signal(null as FlowInstance);
    $flowDefinition = signal(null as FlowDefinition);
    $flowObjectDefinition = signal(null as FlowObjectDefinition);
    // #endregion

    // #region [computeds]
    $isReadOnly = computed(() => Utils.isNotNullOrEmpty(this.$flowInstance()?.finishDate));
    $dateString = computed(() => this.$flowInstance()?.updateDate == null ? '(...)' : new Date(this.$flowInstance().updateDate).toLocaleString());
    $ownerInfo = computed(() => this.$flowInstance()?.ownerInfo || '(...)');
    // #endregion

    // #region [Input/Output]
    @Input() _model: FlowObjectInstance;
    @Input() _flowInstance: FlowInstance;
    @Input() _flowDefinition: FlowDefinition;
    // #endregion

    constructor() { }

    async ngOnInit() {
        Utils.setSignal(this.$flowObjectDefinition, this.$flowDefinition().flowObjectDefinitions.find(x => x.id == this.$model().flowObjectDefinitionId));
    }

    ngOnChanges() {
        this.$model.set(this._model);
        this.$flowInstance.set(this._flowInstance);
        this.$flowDefinition.set(this._flowDefinition);
    }

    // #region [===== private methods =====]
    // #endregion
}
